module.exports = __webpack_public_path__ + "img/mach_machtokenmgt.debf61a.png";